<template>
    <div class="container-fluid">
        <div class="row">
            <cataloglist />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const cataloglist = defineAsyncComponent(() => import("@/components/theme/ecommerce/cataloglist/Cataloglist.vue"))
</script>